module.exports = __webpack_public_path__ + "static/img/logo-sp.1101ac32.png";